<template>
    <v-row no-gutters class="pr-2">
        <v-col cols="auto">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <div :class="controller.model.canEditTemplate() ? 'd-inline' : 'd-none'" v-on="on">
                        <RichTextEditorToolbar id="email-automation-content-toolbar"/>
                    </div>
                </template>
                <span>{{ $t("Format text") }}</span>
            </v-tooltip>
            <v-tooltip v-if="controller.model.getShowPlaceholders()" bottom>
                <template v-slot:activator="{ on }">
                    <div class="d-inline" v-on="on">
                        <RichTextEditorPlaceholders
                            v-if="controller.model.canEditTemplate()"
                            :company-id="controller.model.getCompanyId()"
                            :placeholder-types="placeholderTypes"
                            :rich-text-editor="richTextEditor"
                            @placeholder="$emit('placeholder', $event)"
                            @placeholders="$emit('placeholders', $event)"
                        />
                    </div>
                </template>
                <span>{{ $t("Add placeholder") }}</span>
            </v-tooltip>
            <action-menu
                :tooltip="$t('Actions')"
                :items="controller.model.getActionItems()"
                :absolute="false"
                :open-menu-right="true"
                :open-menu-below="true"
                @action="controller.model.getActionItems()[$event].action()"
            />
        </v-col>
        <v-col cols="auto" class="ml-auto">
            <action-button
                :icon="null"
                @click="controller.handleSendTestEmail()"
            >
                {{ $t('Send test email') }}
            </action-button>
            <secondary-button @click="controller.handleCancel()">
                {{ $t("Cancel") }}
            </secondary-button>
            <primary-button
                :disabled="!controller.model.canEditTemplate()"
                :loading="controller.model.isLoading()"
                test-id="email-template-dialog-save"
                @click="controller.handleSave()"
            >
                {{ $t("Save") }}
            </primary-button>
        </v-col>
    </v-row>
</template>

<script>
import RichTextEditorToolbar from "../../../components/RichTextEditor/RichTextEditorToolbar";
import RichTextEditorPlaceholders from "../../../components/RichTextEditor/RichTextEditorPlaceholders";
import Controller from "./controller"
import { computed } from "@vue/composition-api";
import ApiEmailAutomationPlaceholders from "../../../api/email_automation/placeholders";

export default {
    name: "EditTemplateFooter",
    components: {
        RichTextEditorToolbar,
        RichTextEditorPlaceholders
    },
    props: {
        controller: {
            type: Controller,
            required: true
        },
        richTextEditor: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const { getPlaceholderTypes } = ApiEmailAutomationPlaceholders

        const placeholderTypes = computed(() => {
            if (props.type === 'invoice') {
                return getPlaceholderTypes("invoice")
            }

            return getPlaceholderTypes("email_automation")
        })

        return {
            placeholderTypes
        }
    }
}
</script>

<style scoped>
.format-button.ql-active .v-icon {
    color: var(--v-n4-base) !important;
}
</style>